import { OptimizelyError } from "./optimizly_error";
export class DefaultErrorNotifier {
    constructor(errorHandler, messageResolver, name) {
        this.errorHandler = errorHandler;
        this.messageResolver = messageResolver;
        this.name = name || '';
    }
    notify(error) {
        if (error instanceof OptimizelyError) {
            error.setMessage(this.messageResolver);
        }
        this.errorHandler.handleError(error);
    }
    child(name) {
        return new DefaultErrorNotifier(this.errorHandler, this.messageResolver, name);
    }
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=error_notifier.js.map